import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '@app/core/services/user.service';
import { DossierSearchItem } from '@app/pcs/models';
import { resolveLinkRoute } from '@app/pcs/util/dossier-view-segments';
import { hasValue, toString } from '@util';
import { GridCell } from 'ngrx-data-grid';
import * as R from 'ramda';

export const getLastReadVersion = R.prop('lastReadVersion');
export const getLastVersion = R.prop('version');

@Component({
  templateUrl: './dossier-name-link.component.html'
})
export class DossierNameLinkComponent implements OnInit, GridCell<string> {
  @Input() data: string;

  row: DossierSearchItem;
  path: string[];

  constructor(private userService: UserService) {
  }

  get unread() {
    const version = getLastVersion(this.row);
    const lastReadVersion = getLastReadVersion(this.row);
    return hasValue(version) && hasValue(lastReadVersion) && version !== lastReadVersion;
  }

  ngOnInit(): void {
    const defaultViewKey = this.userService.getDefaultDossierView();
    this.path = ['/app/dossier', toString(this.row.dossierId), ...resolveLinkRoute(defaultViewKey)];
  }

}
